<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col md="6">
                    <ValidationProvider name="semester_id" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox
                                v-model="form.semester_id"
                                :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="program" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('program')">
                            <program-selectbox
                                v-model="form.program_code"
                                :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="quota_type" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('quota_type2')">
                            <multi-selectbox
                                v-model="form.quota_type"
                                :multiple="false"
                                :options="quotaTypeOptions"
                                :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="6">
                    <ValidationProvider name="quota" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('quota')">
                            <b-form-input
                                v-model="form.quota"
                                type="number"
                                :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save').toLocaleUpperCase('tr-TR') }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Components
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox"
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import FashionDesignService from "@/services/FashionDesignService"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        MultiSelectbox,
        SemestersSelectbox,
        ProgramSelectbox
    },
    data() {
        return {
            formLoading: false,
            form: {},
            quotaTypeOptions: [
                {
                    text: 'ÖSYM',
                    value: 'osym'
                },
                {
                    text: this.$t('additional_placement'),
                    value: 'ek_yerlestirme'
                }
            ]
        }
    },
    methods: {
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate()
            if (isValid) {
                this.formLoading = true;
                FashionDesignService.storeQuota(this.form).then((response) => {
                    this.$toast.success(this.$t("api." + response.data.message));
                    this.$emit("createFormSuccess")
                }).catch((error) => {
                    this.showErrors(error, this.$refs.formModalValidate)
                }).finally(() => {
                    this.formLoading = false;
                })
            }
        }
    }
}
</script>
